<template>
    <CDropdown
        inNav
        class="dropDownColor"
        placement="bottom-end"
        add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img
                        src="https://t3.ftcdn.net/jpg/03/91/19/22/360_F_391192211_2w5pQpFV1aozYQhcIw3FqA35vuTxJKrB.jpg"
                        class="c-avatar-img "
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <!-- <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>Account</strong>
        </CDropdownHeader>

        <CDropdownItem>
            <CIcon name="cil-envelope-open" /> Messages
            <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem> -->

        <!-- <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>Settings</strong>
        </CDropdownHeader> -->
        <CDropdownItem class="dropDownColor" @click="profileRoute">
            Profile
        </CDropdownItem>
        <CDropdownItem class="dropDownColor"> Preferences </CDropdownItem>
        <CDropdownItem class="dropDownColor"> Upload photo </CDropdownItem>
        <CDropdownItem class="dropDownColor">
            Switch organization
        </CDropdownItem>

        <CDropdownItem class="dropDownColor" @click="logoutHandler">
            Logout
        </CDropdownItem>
        <!-- <CDropdownItem class="dropDownColor" @click="logoutHandler">
            <CIcon name="cil-lock-locked" /> Logout
        </CDropdownItem> -->
    </CDropdown>
</template>

<script>
export default {
    name: 'TheHeaderDropdownAccnt',
    data() {
        return {
            itemsCount: 42
        };
    },
    methods: {
        profileRoute() {
            this.$router.push('/profileScreen');
        },
        logoutHandler() {
            this.$session.destroy();
            this.$router.push('/login');
        }
    }
};
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
.dropDownColor {
    background-color: #272f51;
    border: none;
}
</style>
